import React from 'react';

import MessagingService from 'services/MessagingService/MessagingService';
import {
  GET_USER_INFO_RESPONSE,
  LOGIN_SUCCESS,
  USER_LOGGED_OUT,
} from 'services/MessagingService/EventNames';
import configureStore from 'app/store/configureStore';
import {
  LOGIN_FLOW_V2_REDUX_LOGIN_ACTION,
  LOGIN_FLOW_V2_REDUX_LOGOUT_ACTION,
} from 'pages/User/State';
import { getAccountStatus } from 'components/BasicInfo/State.js';
import {
  isStudioAdminCheck,
  isStudioOwnerCheck,
} from 'utils/studio';


const store = configureStore.getStore();

/**
 * LoginFlowV2ReduxDispatcher is a component rendered at one place near root of application
 * It's purpose is to dispatch actions directly to redux listening events that comes through messagingService
 * so when user login / logout it will update redux store and handle properly entire UI state of application
 */
function LoginFlowV2ReduxDispatcher() {
  function dispatchAuthenticateUser(data) {
    LOGIN_FLOW_V2_REDUX_LOGIN_ACTION(store.dispatch, data);
    if (isStudioOwnerCheck(data) || isStudioAdminCheck(data)) {
      store.dispatch(getAccountStatus(data));
    }
  }

  function dispatchUserLogout(data) {
    LOGIN_FLOW_V2_REDUX_LOGOUT_ACTION(store.dispatch, data);
  }

  React.useEffect(() => {
    const messagingService = MessagingService();
    messagingService.on(GET_USER_INFO_RESPONSE, dispatchAuthenticateUser);
    messagingService.on(LOGIN_SUCCESS, dispatchAuthenticateUser);
    messagingService.on(USER_LOGGED_OUT, dispatchUserLogout);

    return () => {
      messagingService.off(GET_USER_INFO_RESPONSE, dispatchAuthenticateUser);
      messagingService.off(LOGIN_SUCCESS, dispatchAuthenticateUser);
      messagingService.off(USER_LOGGED_OUT, dispatchUserLogout);
    };
  }, []);

  return null;
}

export default LoginFlowV2ReduxDispatcher;
